import React from 'react';
import { Icon } from 'semantic-ui-react';
import { nth, i18nDescriptionKeys, published } from '../../../common/utils';


// https://github.com/react-tools/react-table#columns
export const COLUMNS = [
  nth,
  {
    Header: () => 'Type',
    maxWidth: 50,
    accessor: 'type',
    Cell: ({ original }) => <Icon name={original.type === 'WORKSHOP' ? 'wrench': 'trophy' }/>
  },
  {
    Header: 'Title',
    accessor: 'title',
    maxWidth: 200
  },
  { Header: 'Where',
    accessor: 'location',
    maxWidth: 200
  },
  {
    Header: () => 'From - Until',
    maxWidth: 210,
    // TODO: 1 - custom sorting by datestring -> timestamp conversion
    // TODO: 2 - sort first by startDate and then endDate
    Cell: row => <div>{row.original.beginDate} - {row.original.endDate}</div>
  },
  i18nDescriptionKeys,
  published,
  {
    Header: 'Registration open',
    accessor: 'published',
    Cell: row => row.original.registrationEnabled ? 'Yes' : 'No',
    maxWidth: 120
  }
  //,
  // {
  //   Header: 'Taaaags',
  //   sortable: false,
  //   Cell: row => <EventStatus data={row.original}/>
  // }
];

export const DEFAULTSORTED = [
  { id: 'title', desc: false },
  { id: 'startDate', desc: false }
];

export const DEFAULTPAGESIZE = 10;



// WEBPACK FOOTER //
// ./src/private/admin/components/Events/table.conf.js